import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
// import elements
import Breadcrumb from '../elements/Breadcrumb';
// import components
import TrackSession from '../track-session';

const TrackSessionPage = (props) => {
  return (
  <div css={css`
    width: 98%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

  `}>
    <div css={css`
      width: 100%;
      margin: 10px;
      flex-grow: 0;
    `}>
      <Breadcrumb label={props.breadcrumbLabel} />
    </div>     
    <div css={css`
      width: 100%;
      margin: 10px;
      flex-grow: 1;
      padding: 30px;
      border-radius: 2px;
      background-color: rgba(143, 206, 238, 0.1);
    `}> 
      <TrackSession 
        SERVER_APIS={props.SERVER_APIS}
      />
    </div>
  </div>)
}

export default TrackSessionPage;